<template>
  <div class="home-box">
    <div class="map_gai_s"></div>
    <div class="map_gai_r"></div>
    <div class="map_gai_b"></div>
    <div class="map_gai_l"></div>
    <div class="head">
      <div class="head-bg">
        <img v-if="$store.state.user.logo" :src="$store.state.user.logo" class="logo"/>
        <h1>{{$store.state.user.title}}</h1>
      </div>
    </div>
    <div class="home-bg">
      <div class="map_gai_s"></div>
      <div class="map_gai_r"></div>
      <div class="map_gai_b"></div>
      <div class="map_gai_l"></div>
      <bg-gmap v-if="$i18n.locale==='en-US'"></bg-gmap>
      <bg-amap v-else></bg-amap>
    </div>
    <div v-if="$i18n.locale==='zh-CN'" class="head_bar_left">
      <img :src="require('../../assets/home_images/weather/myicon/' + weatherData.wea_img +'.png')" class="wea_icon"/>
      <span class="wea_text">{{weatherData.wea}}</span>
      <span>{{weatherData.tem_night}}℃～{{weatherData.tem_day}}℃</span>
      <span>{{weatherData.win}}{{weatherData.win_speed}}</span>
      <img src="@/assets/home_images/head_point.png" class="point" />
      <span class="city">{{weatherData.city}}</span>
    </div>
    
    <div class="head_bar_right">
      <span>{{nowDate.year}}.{{nowDate.month}}.{{nowDate.day}} </span>
      <span>{{nowDate.week}}</span>
      <span>{{nowDate.hour}}:{{nowDate.minute}}:{{nowDate.second}}</span>
    </div>
    <div class="foot-go-system" @click="$router.push('/gis')"><img src="@/assets/home_images/bottom-go-system.png" class="img" /></div>
    <div v-if="resData.camera.number&&videoShow" class="index-video">
      <home-video :itemData="resData.camera"></home-video>
    </div>
    <div class="video-btn" @click="videoShow=!videoShow">
      <i
        :class="videoShow?'el-icon-close':'el-icon-video-play'"
      ></i>
    </div>
    <div class="home-left">
      <div class="home_pad">
        <div class="main-left-top">
          <div class="main-title">
            <h3 class="text">{{$t("home.box1.title")}}</h3>
            <div class="r_block"><span></span><em></em><span></span></div>
          </div>
          <div class="main-content">
            <box1 :itemData="resData.lamp"></box1>
          </div>
        </div>
        <div class="main-left-cen">
          <div class="main-title">
            <h3 class="text">{{$t("home.box3.title")}}</h3>
            <div class="r_block"><span></span><em></em><span></span></div>
          </div>
          <div class="main-content">
            <box3 :itemData="resData.lamp" :camera="resData.camera.all_number" :ip="resData.ip.total" :alarm="resData.one_key.total"></box3>
          </div>
        </div>
        <div class="main-left-bot">
          <div class="main-title">
            <h3 class="text">{{$t("home.box2.title")}}</h3>
            <div class="r_block"><span></span><em></em><span></span></div>
          </div>
          <div class="main-content">
            <box2 :itemData="resData.ip"></box2>
          </div>
        </div>
      </div>
    </div>
    <div class="home-right">
      <div class="home_pad">
        <div class="main-right-top">
          <div class="main-title">
            <h3 class="text">{{$t("home.box4.title")}}</h3>
            <div class="r_block"><span></span><em></em><span></span></div>
          </div>
          <div class="main-content">
            <box4 :itemData="resData.env" :lamp_name="resData.lamp.name"></box4>
          </div>
        </div>
        <div class="main-right-cen">
          <div class="main-title">
            <h3 class="text">{{$t("home.box5.title")}}</h3>
            <div class="r_block"><span></span><em></em><span></span></div>
          </div>
          <div class="main-content">
            <box5 :itemData="resData.screen"></box5>
          </div>
        </div>
        <div class="main-right-bot">
          <div class="main-title">
            <h3 class="text">{{$t("home.box6.title")}}</h3>
            <div class="r_block"><span></span><em></em><span></span></div>
          </div>
          <div class="main-content">
            <box6 :itemData="resData.alarm"></box6>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import axios from 'axios'
import systemPublicApi from "@/api/system/public";
import box1 from "@/components/home/box1.vue";
import box2 from "@/components/home/box2.vue";
import box3 from "@/components/home/box3.vue";
import box4 from "@/components/home/box4.vue";
import box5 from "@/components/home/box5.vue";
import box6 from "@/components/home/box6.vue";
import homeVideo from "@/components/home/video.vue";
import bgAmap from "./bgAmap.vue";
import bgGmap from "./bgGmap.vue";
export default {
  components: {
    box1,
    box2,
    box3,
    box4,
    box5,
    box6,
    homeVideo,
    bgAmap,
    bgGmap
  },
  data() {
    return {
      videoShow: false,
      resData: {
        lamp: {
          total: 0,
          online: 0,
          malfunction: 0,
          lamp_light: 0,
          light: 1,
          voltage: 220,
          current: 1,
          power: 220,
          lamp_id: 2,
          colorTemperature: 25,
          cost_electricity: 100,
          total_electricity: 2645.5,
          save_electricity: 2568.06,
          name: '默认灯杆',
          Power_factor: 0.0000039
        },
        camera: {
          number:'',
          channel: 1,
          all_number: 0,
          online_number: 0
        },
        env: [],
        ip: {
          total: 0,
          online: 0,
          Offline: 0
        },
        manhole: {
          total: 0,
          online: 0,
          Offline: 0,
          warning: 0
        },
        one_key: {
          total: 0,
          online: 0,
          Offline: 0
        },
        screen: {
          total: 0,
          program: 0,
          url: []
        },
        alarm: []
      },
      lampInfo: {
        name: "",
        lamp_id: "",
        stg_id: "",
        stg_name: "",
        light: "",
        ms: "",
        sb: [],
        camera_list: [],
      },
      
      weatherData: {
        nums:	246,
        cityid:	"101190101",
        city:	"南京",
        date:	"2022-05-25",
        week:	"星期三",
        update_time: "14:00",
        wea: "多云",
        wea_img: "yun",
        tem: "29",
        tem_day: "31",
        tem_night:"20",
        win: "东风",
        win_speed: "2级",
        win_meter: "6km/h",
        air: "58",
        pressure: "1004",
        humidity: "48%"
      },
      nowDate: {
        year: '',
        month: '',
        day: '',
        week: '',
        hour: '',
        minute: '',
        second: '',
      },
      timer: null,
      timer2: null,
      timer3: null
    };
  },
  methods: {
    getData() {
      //获得首页数据
      systemPublicApi.systemIndex().then((res) => {
        if (res.data.code === 1000) {
          this.resData = res.data.data;
          // console.log('this.resData', this.resData)
        }
      });
    },
    getNowTemp() {
      const that = this
      const url = 'https://weather.qyltd.com/free/day/index.php?appid=31736539&appsecret=mcKVlC8B&unescape=1'
      axios({
        method: 'get',
        url: url
      }).then(function(res) {
        if(res&&res.data.code===1000){
          that.weatherData = res.data.data
        }
      })
    },
    formatDate() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; //月
      let day = date.getDate(); // 日
      let week = date.getDay(); // 星期
      let weekArr = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      let hour = date.getHours(); // 时
      hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
      let minute = date.getMinutes(); // 分
      minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
      let second = date.getSeconds(); // 秒
      second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
      this.nowDate = {
        year: year,
        month: month,
        day: day,
        week: weekArr[week],
        hour: hour,
        minute: minute,
        second: second
      }
    }
    
  },
  mounted() {
    // 下面为制作定时器（首页模块数据）
    this.getData();
    if (this.timer) {
      clearInterval(this.timer);
    } else {
      this.timer = setInterval(() => {
        setTimeout(this.getData(), 0);
      }, 6 * 1000);
    }

    // 下面为制作定时器（倒计时）
    this.formatDate();
    if (this.timer2) {
      clearInterval(this.timer2);
    } else {
      this.timer2 = setInterval(() => {
        setTimeout(this.formatDate(), 0);
      }, 500);
    }

    // 下面为制作定时器（天气预报）
    this.getNowTemp()
    if (this.timer3) {
      clearInterval(this.timer3)
    } else {
      this.timer3 = setInterval(() => {
        setTimeout(this.getNowTemp(), 0)
      }, 60 * 1000)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null

    clearInterval(this.timer2)
    this.timer2 = null

    clearInterval(this.timer3)
    this.timer3 = null
    
  }
};
</script>
<style lang='less'>
@color-primary:#1de7ff;
.home-box {
  position: relative;
  width: 100%;
  height: 100%;
  background: #020f1e;
  
  .map_gai_s{
    width:100%;
    height:177px;
    position: absolute;
    left:0;
    top:0;
    background-position: 0 0;
    background-repeat: repeat-x;
    background-image: url(../../assets/home_images/map_gai_s.png);
    z-index: 2;
  }
  .map_gai_r{
    width:250px;
    height:100%;
    position: absolute;
    right:0;
    bottom:0;
    top:0;
    background-size: 100% auto;
    background-image: url(../../assets/home_images/map_gai_r.png);
    background-position: repeat-y;
    z-index: 2;
  }
  .map_gai_b{
    width:100%;
    height:177px;
    position: absolute;
    left:0;
    bottom:0;
    background-size: auto 100%;
    background-image: url(../../assets/home_images/map_gai_b.png);
    background-position: repeat-x;
    z-index: 2;
  }
  
  .map_gai_l{
    width:250px;
    height:100%;
    position: absolute;
    left:0;
    bottom:0;
    top:0;
    background-size: 100% auto;
    background-image: url(../../assets/home_images/map_gai_l.png);
    z-index: 2;
    background-position: repeat-y;
  }
  .head {
    position: absolute;
    height: 90px;
    left: 0;
    right: 0;
    top: 0;
    z-index: 999;
    background: url("../../assets/home_images/head-bg.png") center bottom no-repeat;
    .head-bg {
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .logo{
      margin-right: 10px;
      height:46px;
    }
    h1 {
      font-size:43px;
      color: #fff;
      font-weight: normal;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      font-family: YSBT;
      background: -webkit-linear-gradient(to bottom, #ffffff 0%, #ffffff 20%, #00aeff 100%); /* Chrome, Safari */
      background: linear-gradient(to bottom, #ffffff 0%, #ffffff 20%, #00aeff 100%); /* 标准语法 */
      -webkit-background-clip: text; /* Chrome, Safari */
      background-clip: text;
      -webkit-text-fill-color: transparent; /* Chrome, Safari */
      color: transparent; /* 兼容不支持background-clip的浏览器 */
      // text-shadow: 0px 0px 9px #159AFF;
    }
  }

  .head_bar_left{
    position: absolute;
    left:20px;
    top: 10px;
    height:50px;
    z-index: 1000;
    display: flex;
    align-items: center;
    img.wea_icon{
      width:auto;
      height:24px;
      margin-top:-2px;
    }
    img.point{
      width:auto;
      height:22px;
      margin-left:60px;
    }
    span{
      margin-left: 20px;
      color:#fff;
      font-size:15px;
      font-family: Bahnschrift, Arial, sans-serif;
    }
    .wea_text{
      margin-left: 4px;
    }
    .city{
      margin-left:2px;
    } 
  }

  .head_bar_right{
    position: absolute;
    right: 30px;
    top:25px;
    margin-left:380px;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-weight: normal;
    span{
      margin-left: 30px;
      color:#fff;
      font-size:18px;
      font-family: Bahnschrift, Arial, sans-serif;
    }
  }
  .home-left {
    position: absolute;
    width: 460px;
    min-width: 420px;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 9;
    .home_pad {
      padding-left: 20px;
      .main-left-top {
        padding: 15px 0;
        height: 40%;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
      }
      .main-left-cen {
        padding: 15px 0;
        height: 35%;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
      }
      .main-left-bot {
        padding: 15px 0;
        height: 25%;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
      }
    }
  }
  .home-right {
    position: absolute;
    width: 460px;
    min-width: 420px;
    height: 100%;
    right: 0;
    top: 0;
    z-index: 9;
    .home_pad {
      padding-right: 20px;
      .main-right-top {
        padding: 15px 0;
        height: 33%;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
      }
      .main-right-cen {
        padding: 15px 0;
        height: 30%;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
      }
      .main-right-bot {
        padding: 15px 0;
        height: 37%;
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
      }
    }
  }
  
  .home-bg {
    position: absolute;
    top:70px;
    left:350px;
    right:350px;
    bottom:0px;
    overflow: hidden;
    background: none;
    z-index: 3;
    .map_gai_s{
      width:100%;
      height:177px;
      position: absolute;
      left:0;
      top:0;
      background-position: 0 0;
      background-repeat: repeat-x;
      background-image: url(../../assets/home_images/map_gai_s.png);
      z-index: 2;
    }
    .map_gai_r{
      width:250px;
      height:100%;
      position: absolute;
      right:0;
      bottom:0;
      top:0;
      background-size: 100% auto;
      background-image: url(../../assets/home_images/map_gai_r.png);
      background-position: repeat-y;
      z-index: 2;
    }
    .map_gai_b{
      width:100%;
      height:177px;
      position: absolute;
      left:0;
      bottom:0;
      background-size: auto 100%;
      background-image: url(../../assets/home_images/map_gai_b.png);
      background-position: repeat-x;
      z-index: 2;
    }
    
    .map_gai_l{
      width:250px;
      height:100%;
      position: absolute;
      left:0;
      bottom:0;
      top:0;
      background-size: 100% auto;
      background-image: url(../../assets/home_images/map_gai_l.png);
      z-index: 2;
      background-position: repeat-y;
    }
  }

  .home_pad {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 60px;
    padding-bottom: 10px;
    position: relative;
    overflow: hidden;
    .main-title{
      width: 100%;
      height:34px;
      display: flex;
      align-items: center;
      background-image: url(../../assets/home_images/title-bg.png);
      background-position: 0 0;
      background-size: auto 100%;
      background-repeat: no-repeat;
      position: relative;
      overflow: hidden;
      padding-left: 45px;
      .text{
        color: #fff;
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 5px;
      }
      .r_block{
        position: absolute;
        right:20px;
        bottom:20px;
        display: flex;
        align-items: center;
        span{
          width:2px;
          height:7px;
          background: #18567d;
          display: block;
        }
        em{
          width:5px;
          height:7px;
          background: #01162b;
          display: block;
        }
      }
    }
    .bottom{
      height:4px;
      display: flex;
      align-items: center;
      justify-content: flex-start ;
      width: 100%;
      background-image: url(../../assets/home_images/con_bot.png);
      background-position: 0 center;
      background-repeat: no-repeat;
      position: absolute;
      bottom: 15px;
      left: 0;
      .r_block{
        position: absolute;
        right:0;
        bottom:0px;
        display: flex;
        align-items: center;
        span{
          width:4px;
          height:4px;
          background: #1de7ff;
          display: block;
        }
        em{
          width:10px;
          height:4px;
          background: #01162b;
          display: block;
        }
      }
    }
    .main-content{
      position: absolute;
      top:54px;
      left:0;
      right:0;
      bottom: 19px;
      background-image: url(../../assets/home_images/item-con-bg.png);
      background-position: center  bottom;
      background-repeat: no-repeat;
      background-size: 92% auto;
      box-sizing: border-box;
    }
  }

  .foot-go-system{
    width:54.42%;
    position: absolute;
    left:22.79%;
    bottom: 0;
    line-height: 0;
    z-index: 9999;
    cursor: pointer;
    text-align: center;
    .img{
      max-width: 100%;
      height: auto;
    }
  }

  .index-video{
    width:50%;
    position: absolute;
    left:25%;
    right:25%;
    top:90px;
    bottom: 65px;
    line-height: 0;
    z-index: 999;
    cursor: pointer;
    text-align: center;
    background-color: #020f1e;
    border: 2px solid #153471;
  }

  .video-btn{
    width: 40px;
    height: 40px;
    background-color: #13b4ff;
    display: flex;
    align-items: center;
    justify-content: center;
    top:92px;
    right:25%;
    position: absolute;
    z-index: 1000;
    color:#fff;
    font-size: 24px;
    margin-right: 2px;
    cursor: pointer;
  }
  

  @media screen and (max-width: 1440px){
    .head_bar_left{
      margin-right:340px;
      img.point{
        margin-left:40px;
      }

    }
    .head_bar_right{
      margin-left:340px;
    }
    .go-system {
      right: 40px;
    }
  }
}


</style>